import styled from 'styled-components';
import COLORS from '../../../utils/colors.constants';
const Title = styled.h1`
font-family: Roboto, sans-serif;
color : ${COLORS.AZUL};
`;

export default Title;